import { api } from "../api/axios";

export const BillService = {
  getBills: async (params) => {
    const { data } = await api.get("/bills", { params });
    return data;
  },

  getBillById: async (id) => {
    const { data } = await api.get(`/bills/${id}`);
    return data;
  },

  generateBills: async (payload) => {
    const { data } = await api.post("/bills/generate", payload);
    return data;
  },

  issueBills: async (payload) => {
    const { data } = await api.patch("/bills/issue", payload);
    return data;
  },

  deleteDrafts: async (payload) => {
    const { data } = await api.delete("/bills/drafts", { data: payload });
    return data;
  },
};

export const getCurrentTerm = async () => {
  const { data } = await api.get("/current-term");
  return data;
};

export const AdjustmentService = {
  getByBill: async (billId) => {
    const { data } = await api.get(`/bill-adjustments/${billId}`);
    return data;
  },

  apply: async (billId, payload) => {
    const { data } = await api.post(`/bill-adjustments/${billId}`, payload);
    return data;
  },

  remove: async (adjustmentId) => {
    const { data } = await api.delete(
      `/bill-adjustments/remove/${adjustmentId}`,
    );
    return data;
  },
};
